/**
 * Utilitário para gerenciar versão da aplicação
 * Versão é injetada automaticamente pelo Vite durante o build
 */

const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.0.0';
const BUILD_DATE = new Date().toISOString().split('T')[0];

/** Retorna a versão da aplicação */
export function readVersionFromPackage() {
  return APP_VERSION;
}

/** Obtém informações completas da versão */
export function getVersionInfo() {
  return {
    version: APP_VERSION,
    buildDate: BUILD_DATE,
    fullVersion: `v${APP_VERSION} (${BUILD_DATE})`
  };
}